<template>
  <AdminPanel />
</template>

<script>
import AdminPanel from "./admin-template/components/AdminPanel.vue";

export default {
  name: "App",
  components: { AdminPanel },
};
</script>
